import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { EmployeeProfileFeature } from "@/features/employee-profile/EmployeeProfileFeature";
import { useSwitchToLinkedAccount } from "@/features/auth/hooks/useSwitchToLinkedAccount";
import { memoLogbookSearchSchema } from "@/features/memo-logbook/useMemoLogbookFilters";



const searchSchema = z.object({
  tab: z.string().optional(),
  account: z.coerce.number().int().positive().optional(),
  ...memoLogbookSearchSchema,
});

export const Route = createFileRoute("/employees/$employeeId/profile")({
  component: EmployeeProfilePage,
  staticData: { authorize: true },
  validateSearch: searchSchema,
});

function EmployeeProfilePage() {
  const params = Route.useParams();
  const { tab, account } = Route.useSearch();
  const employeeId = Number(params.employeeId)
  const navigate = useNavigate({ from: Route.fullPath });
  const switchingAccount = useSwitchToLinkedAccount(account);

  if (switchingAccount) return null;

  return (
    <EmployeeProfileFeature
      employeeId={employeeId}
      initialTab={tab}
      onTabChange={(next) => navigate({ search: (current) => ({ ...current, tab: next }), replace: true })}
    />
  );
}
